export const API_URL = process.env.REACT_APP_BACKEND_URL
const endpoints = {
  // Auth
  BASE_API: API_URL + "/api/v1/",
  SIGN_IN: API_URL + "/api/v1/auth/signin",
  PROFILE: (params: any) => API_URL + `/api/v1/users/${params}`,
  FORGOT_PASSWORD: API_URL + "/api/v1/auth/forgot-password",
  RESET_PASSWORD: API_URL + "/api/v1/auth/reset-password",
  EDIT_PROFILE: (userId: any) => API_URL + `/api/v1/users/${userId}`,
  CHANGE_PASSWORD: API_URL + "/api/v1/users/change-password",

  // Role
  VIEW_LIST_ROLE: API_URL + "/api/v1/roles",

  // Users
  VIEW_LIST_USER: API_URL + "/api/v1/users",
  SEARCH_LIST_USER: API_URL + "/api/v1/admin/search-users",
  CREATE_USER: API_URL + "/api/v1/users",
  VIEW_USER: (viewId: any) => API_URL + `/api/v1/users/${viewId}`,

  // Employee
  EMPLOYEE_URL: API_URL + "/api/v1/employee",
  VIEW_EMPLOYEE: (params: any) => API_URL + `/api/v1/employee/${params}`,
  VIEW_EMPLOYEE_BY_USER: (params: any) => API_URL + `/api/v1/employee/byuser/${params}`,

  // Employee Performance
  EMPLOYEE_PERFORMANCE: API_URL + "/api/v1/employee-performance",
  DETAIL_EMPLOYEE_PERFORMANCE: (id: number) =>
    API_URL + `/api/v1/employee-performance/${id}`,
  EMPLOYEE_PERFORMANCE_EXPORT:
    API_URL + "/api/v1/employee-performance/export",
  EMPLOYEE_PERFORMANCE_EXPORT_SUMMARY:
    API_URL + "/api/v1/employee-performance/export-summary",
  EMPLOYEE_PERFORMANCE_BULK:
    API_URL + "/api/v1/employee-performance/bulk",

  // BRANCH
  BRANCH: API_URL + "/api/v1/branch",
  DETAIL_BRANCH: (id: number) => API_URL + `/api/v1/branch/${id}`,
  
  // BRANCH Group
  BRANCH_GROUP: API_URL + "/api/v1/branch-group",
  DETAIL_BRANCH_GROUP: (id: number) => API_URL + `/api/v1/branch-group/${id}`,
  BRANCH_GROUP_TEMPLATE: API_URL + "/api/v1/branch-group/template",
  BRANCH_GROUP_UPLOAD: API_URL + "/api/v1/branch-group/upload",
  
  // Employee Group
  EMPLOYEE_GROUP: API_URL + "/api/v1/employee-group",
  DETAIL_EMPLOYEE_GROUP: (id: number) => API_URL + `/api/v1/employee-group/${id}`,

  DIVISION: API_URL + "/api/v1/division",
  DETAIL_DIVISION: (id: number) => API_URL + `/api/v1/division/${id}`,
  DIVISION_BULK_DOWNLOAD: API_URL + "/api/v1/division/bulk",
  DIVISION_BULK_UPLOAD: API_URL + "/api/v1/division/bulk",
  DIVISION_PUBLIC_LIST: API_URL + "/api/v1/division/public/list",

  //report
  REPORT:  API_URL + `/api/v1/report`,
  REPORT_DOWNLOAD:  API_URL + `/api/v1/report/download`,
  REPORT_UPLOAD:  API_URL + `/api/v1/report/upload`,
  REPORT_UPLOAD_XENDIT:  API_URL + `/api/v1/report/upload-xendit`,
  REPORT_UPLOAD_MIDTRANS:  API_URL + `/api/v1/report/upload-midtrans`,
  DETAIL_REPORT: (id: number) => API_URL + `/api/v1/report/${id}`,
  ALL_REPORT: (params: string) => API_URL + `/api/v1/report/all/${params}`,
  VIEW_ALL_REPORT: (params: string) => API_URL + `/api/v1/report/viewall/${params}`,

  //sales
  SALES:  API_URL + `/api/v1/sales`,
  DETAIL_SALES: (id: number) => API_URL + `/api/v1/sales/${id}`,

  //pl
  PL:  API_URL + `/api/v1/pl`,
  PL_EXPORT: API_URL + `/api/v1/pl/export`,
  DETAIL_PL: (id: number) => API_URL + `/api/v1/pl/${id}`,
  PL_SUMMARY_BRANCH: API_URL + `/api/v1/pl/summary/branch`,
  PL_SUMMARY_REGION: API_URL + `/api/v1/pl/summary/region`,
  PL_DOWNLOAD_BRANCH: API_URL + `/api/v1/pl/summary/branch/download`,
  PL_DOWNLOAD_REGION: API_URL + `/api/v1/pl/summary/region/download`,
  PL_DOWNLOAD_TEMPLATE: API_URL + `/api/v1/pl/template-pl`,
  PL_UPLOAD_TEMPLATE: API_URL + `/api/v1/pl/upload-pl`,
  PL_DOWNLOAD_MUTASI_TEMPLATE: API_URL + `/api/v1/pl/template-mutasi`,
  PL_UPLOAD_MUTASI_TEMPLATE: API_URL + `/api/v1/pl/upload-mutasi`,
  PL_BEP: API_URL + `/api/v1/pl/bep`,
  PL_BEP_EXPORT: API_URL + `/api/v1/pl/bep-export`,

  // COA
  COA: API_URL + "/api/v1/coa",
  DETAIL_COA: (code: string) => API_URL + `/api/v1/coa/${code}`,

  // Commission
  COMMISSION: API_URL + "/api/v1/commission",
  COMMISSION_DETAIL: (viewId: any) => API_URL + `/api/v1/commission/${viewId}`,

  // Mystery Shopper
  MYSTERY_SHOPPER_PUBLIC_CREATE: API_URL + "/api/v1/mystery-shopper/public/create",
  MYSTERY_SHOPPER_LIST: API_URL + "/api/v1/mystery-shopper",
  MYSTERY_SHOPPER_EMPLOYEES: API_URL + "/api/v1/mystery-shopper/employees",
};

export default endpoints;
